import {ROUTE_PATH} from "../../../../shared/utils/constants";
import {Business, ManageSearch, Notifications, Person, Receipt} from "@mui/icons-material";
import {T} from "@tolgee/react";

const drawerListItems = [
    {
        text: <T keyName="nav-companies" defaultValue="Companies"/>,
        to: ROUTE_PATH.companiesManagement,
        icon: <Business />
    },
    {
        text: <T keyName="nav-licences" defaultValue="Licences"/>,
        to: ROUTE_PATH.licenses,
        icon: <Receipt />
    },
    {
        text: <T keyName="nav-users" defaultValue="Users"/>,
        to: ROUTE_PATH.usersManagement,
        icon: <Person />
    },
    {
        text: <T keyName="nav-audit-log" defaultValue="Audit Log"/>,
        to: ROUTE_PATH.auditLog,
        icon: <ManageSearch />
    },
    {
        text: <T keyName="nav-alerts" defaultValue="Alerts"/>,
        to: ROUTE_PATH.alerts,
        icon: <Notifications />
    },
]

export default drawerListItems;
